import { CollectionConfig } from "@rebasepro/types";

/**
 * Email templates — the mail the team sends more than once.
 *
 * The text that closes a process shipped hardcoded in the panel on
 * 2026-09-06; the invitation to the 360° programme went out from Gmail by
 * hand to every reply. Both are rows here now, and the composer offers them.
 *
 * `{{nombre}}` and `{{empresa}}` are the placeholders the composer fills when
 * it knows the recipient's first name and the employer's name, and leaves in
 * place for the operator when it does not — a visible `{{nombre}}` in a draft
 * is a thing to fix; a silently blank greeting is a thing that gets sent.
 *
 * Seeded by drizzle/0054 with the texts the mailbox already held.
 */
const emailTemplatesCollection: CollectionConfig = {
    name: "Plantillas de correo",
    singularName: "Plantilla",
    slug: "email-templates",
    table: "email_templates",
    securityRules: [
        {
            name: "admin_full_access",
            operation: "all",
            roles: ["admin"]
        }
    ],
    properties: {
        id: {
            name: "ID",
            type: "string",
            isId: "uuid"
        },
        name: {
            name: "Nombre",
            type: "string",
            // Unique, as drizzle/0054 created it (email_templates_name_key) and
            // as its own seed relies on with ON CONFLICT (name).
            validation: { required: true, unique: true }
        },
        audience: {
            name: "Para",
            type: "string",
            enum: [
                { id: "candidate", label: "Candidatos", color: "green" },
                { id: "employer", label: "Empresas", color: "blue" },
                { id: "any", label: "Cualquiera", color: "gray" }
            ],
            defaultValue: "any"
        },
        subject: {
            name: "Asunto",
            type: "string",
            validation: { required: true }
        },
        body: {
            name: "Texto",
            type: "string",
            validation: { required: true },
            description: "{{nombre}} se convierte en el nombre de pila de quien lo recibe; {{empresa}} en el nombre de la empresa.",
            admin: { multiline: true }
        },
        created_at: {
            name: "Creada",
            type: "date",
            autoValue: "on_create"
        },
        updated_at: {
            name: "Actualizada",
            type: "date",
            autoValue: "on_update"
        }
    },
    admin: {
        group: "Correo",
        icon: "FileText",
        sort: ["name", "asc"],
        listProperties: ["name", "audience", "subject", "updated_at"]
    }
};

export default emailTemplatesCollection;
